import { ref } from 'vue';
import ApiService from '@/core/services/api.service';
import { removeAccents } from '@/utils/common';

export default function useProductFilters() {
  const cateOptions = ref([{ data: [] }]);
  const filteredCateOptions = ref([]);
  const brandOptions = ref([]);
  const filteredBrandOptions = ref([]);

  const fetchCategories = async () => {
    try {
      const param = {
        page: 1,
        limit: 1000,
        name: '',
        code: '',
      };

      const { data } = await ApiService.query('category', { params: param });

      cateOptions.value[0].data = [];

      data.data.list_caterogy.forEach((element) => {
        let name = '';
        if (element.level === 1) {
          name = '-' + element.name;
        } else if (element.level === 2) {
          name = '--' + element.name;
        } else if (element.level === 3) {
          name = '---' + element.name;
        } else if (element.level === 4) {
          name = '----' + element.name;
        } else if (element.level === 5) {
          name = '-----' + element.name;
        } else if (element.level === 6) {
          name = '------' + element.name;
        } else {
          name = element.name;
        }

        const item = {
          id: element.id,
          suggestionName: name,
          name: element.name,
        };

        cateOptions.value[0].data.push(item);
      });

      filteredCateOptions.value = [...cateOptions.value[0].data];
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const fetchBrands = async () => {
    try {
      const param = {
        page: 1,
        pageSize: 1000,
        name: '',
      };

      const response = await ApiService.query('brands', { params: param });

      response.data.data.brands.forEach((item) => {
        const brand = {
          code: item.id,
          name: item.name,
          checked: false,
        };

        brandOptions.value.push(brand);
      });

      filteredBrandOptions.value = [...brandOptions.value];
      return brandOptions.value;
    } catch (error) {
      console.error('Error fetching brands:', error);
    }
  };

  const filterCategoriesByText = (text) => {
    return cateOptions.value[0].data.filter((item) => {
      return (
        removeAccents(item.name)
          .toLowerCase()
          .indexOf(removeAccents(text.toLowerCase())) > -1
      );
    });
  };

  const filterBrandsByText = (text) => {
    return brandOptions.value[0].data.filter((item) => {
      return (
        removeAccents(item.name)
          .toLowerCase()
          .indexOf(removeAccents(text.toLowerCase())) > -1
      );
    });
  };

  return {
    cateOptions,
    filteredCateOptions,
    brandOptions,
    filteredBrandOptions,
    fetchCategories,
    fetchBrands,
    filterCategoriesByText,
    filterBrandsByText,
  };
}
